// @flow
import React, { PureComponent } from 'react';
import DelightfulExplosion from 'app/common/react/components/growth/activation/BoardCreateSuccess/DelightfulExplosion';
import i18n from 'app/common/lib/i18n';
import { Box, Mask } from 'gestalt';

const fadeStyles = (fadeIn: boolean) => {
  const animationDelay = fadeIn ? '0.4' : '0.8';
  return {
    __style: {
      transition: `opacity ${animationDelay}s ease`,
      opacity: fadeIn ? 1 : 0,
      padding: '70px',
    },
  };
};

type NuxChecklistCelebrationProps = {|
  handleComplete: () => void,
|};

type NuxChecklistCelebrationState = {|
  fadeCelebrationIn: boolean,
|};

class NuxChecklistCelebration extends PureComponent<
  NuxChecklistCelebrationProps,
  NuxChecklistCelebrationState,
> {
  constructor(props: NuxChecklistCelebrationProps) {
    super(props);
    this.state = {
      fadeCelebrationIn: false,
    };
  }

  componentDidMount() {
    const { handleComplete } = this.props;
    window.requestAnimationFrame(() => this.setState({ fadeCelebrationIn: true }));
    setTimeout(() => this.setState({ fadeCelebrationIn: false }), this.fadeOutAnimationDelayMS);
    setTimeout(handleComplete, this.completeExperienceDelayMS);
  }

  explosionAnimationDelayMS = 800;
  completeExperienceDelayMS = 3400;
  fadeOutAnimationDelayMS = 2600;

  render() {
    const { fadeCelebrationIn } = this.state;
    return (
      <Box display="flex" color="white" alignItems="center" justifyContent="center">
        <Mask shape="rounded" width="100%" height="100%">
          <DelightfulExplosion
            delay={this.explosionAnimationDelayMS}
            startAnimation={fadeCelebrationIn}
          >
            <Box width="100%" dangerouslySetInlineStyle={fadeStyles(fadeCelebrationIn)}>
              <Box
                display="flex"
                height="100%"
                width="100%"
                alignItems="center"
                justifyContent="center"
              >
                <h1 style={{ color: '#333', zIndex: 9999, fontSize: '3em' }}>
                  {i18n._(
                    'You got this!',
                    'Celebratory text to encourage user to keep on completing more actions',
                  )}
                </h1>
              </Box>
            </Box>
          </DelightfulExplosion>
        </Mask>
      </Box>
    );
  }
}

export default NuxChecklistCelebration;
